module.exports = __webpack_public_path__ + "img/research.aeebf5f9.png";